// extracted by mini-css-extract-plugin
export default {"subrow":"sub-row_subrow__IoDz0"};